var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-app-header-time",class:("c-app-header-time" + _vm.customClass)},[_c('div',[_c('time',{attrs:{"role":"none","datetime":(_vm.currentYear + "-11")},domProps:{"innerHTML":_vm._s(_vm.$t('global.date'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }